import { EABFilterImplementationType, type FilterOption } from "@/graphql";
import type { EventFilter } from "../FilterTypes";
import BoardFilterUI from "../ui/BoardFilterUI.vue";
import BoardFilterBadge from "../ui/badges/BoardFilterBadge.vue";

export default class BoardFilter implements EventFilter {
  constructor(
    public readonly boardId: number,
    public readonly isNegated?: boolean,
  ) {}

  static readonly UI = BoardFilterUI;
  static readonly Badge = BoardFilterBadge;

  getEventFilter(): FilterOption {
    return {
      filter: {
        type: EABFilterImplementationType.EVENT_BOARD_ID,
        value: { value: [this.boardId], negated: this.isNegated ?? false },
      },
    };
  }
}
